import { keyBy } from 'lodash';

export function selectedStorePageId(state) {
  return state.selectedStorePageId;
}

export function storePageList(state) {
  return state.storePageList;
}

export function storePages(state) {
  return keyBy(state.storePageList, page => page.id);
}

export function storePageIds(state) {
  return state.storePageList.map(page => (page.id));
}



// WEBPACK FOOTER //
// ./src/app/store-pages/store/getters.js